//
//== FANCYBOX
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {
  Toolbar: {
    display: {
      middle: [
        "zoomIn",
        "zoomOut",
      ],
      right: ["slideshow", "thumbs", "close"],
    },
  },
});